/**
 * @template CoreReducerState Type for properties Core reducer redux state.
 */

import { UserRole } from "@models/interfaces/user-roles";

interface CoreReducerState {
    loadingCount: number;
    loadingText: string;
    userProfile: any;
    showTab: boolean;
    isLoggedIn: boolean;
    userAccess: number;
    userId: number;
    userEmailId: string;
    userFirstName: string;
    userLastName: string;
    userRole: UserRole | null;
    loginType: string;
    accessToken: string;
}

/** Initial state of Core reducer redux state. */
export const initialState: CoreReducerState = {
    loadingCount: 0,
    loadingText: 'Processing request...',
    userProfile: null,
    showTab: true,
    isLoggedIn: false,
    userAccess: 0,
    userId: null,
    userEmailId: '',
    userFirstName: "",
    userLastName: "",
    userRole: null,
    loginType: "",
    accessToken: ""
};
